<select [(ngModel)]="country" (ngModelChange)="changeCountry($event)"
        [ngClass]="{'border-invalid' : required && !country}"
        [required]="required" [disabled]="disabled" class="form-select rounded">
  <ng-container *ngFor="let country of countries">
    <option [ngValue]="country" [innerHTML]="countryFormatter(country)"></option>
  </ng-container>
</select>
